import styled from 'styled-components';

export const ContainerLoading = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
